module.exports = __webpack_public_path__ + "static/media/National_University_of_Cambodia_logo.26a71d6e.png";